import { Component, OnInit } from '@angular/core';

import { Container, Report } from 'src/app/shared/models';
import { TinyTextEditor } from 'src/app/shared/constants';
import { ModalService } from 'src/app/shared/modules/modal';
import { NotificationService, TpReportGeneratorService, SessionService } from 'src/app/shared/services';
import { ClosableModalWithErrorResponseModel } from '../../../base/closable-modal-with-error-response-model';

@Component({
  selector: 'org-chart-summary-modal',
  templateUrl: 'org-chart-summary-modal.component.html'
})

export class OrgChartSummaryModalComponent extends ClosableModalWithErrorResponseModel<void> implements OnInit {
  data: Report;
  tinyInit = TinyTextEditor.INIT;
  workingContainer: Container;
  containerId: number;
  orgChartSummary: string;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _tpReportGeneratorService: TpReportGeneratorService,
    private _sessionService: SessionService,
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.getWorkingContainer();
    this.getOrgChartSummary();
  }

  exitModal(): void { this.closeAllModals(); }

  private getOrgChartSummary(): void {
    this._tpReportGeneratorService.getOrgChartSummary(this.data.reportId, this.containerId).subscribe(({ data }) => {
      this.orgChartSummary = data.userInputData;
    });
  }

  saveOrgChartSummary(): void {
    if (this.orgChartSummary === undefined || this.orgChartSummary === null) {
      this.exitModal();
    } else {
      this._tpReportGeneratorService.saveOrgChartSummary(this.orgChartSummary, this.data.reportId, this.containerId).subscribe(() => {
        this.success();
        this.exitModal();
      });
    }
  }

  private getWorkingContainer(): void {
    this.workingContainer = this._sessionService.getWorkingContainer();
    const { containerId } = this.workingContainer;
    this.containerId = containerId;
  }
}
